export const sortElements = (elements, sortOrder, callback) => {
    elements.sort((a, b) => {
        let elementA = callback(a);
        let elementB = callback(b);
        if (elementA < elementB) {
            return sortOrder === "descending" ? 1 : -1;
        }
        if (elementA > elementB) {
            return sortOrder === "descending" ? -1 : 1;
        }
        return 0;
    });
};

export const sortVersions = (ver1, ver2) => {
    const normalizedVersions = [ver1.versionNumber, ver2.versionNumber].map(x =>
        x.split(".").reduce((a, b, i) => a + parseInt(b) / Math.pow(10, 2 * i), 0)
    );
    return normalizedVersions[0] < normalizedVersions[1] ? 1 : -1;
};

export const getValueFromPropertyPath = (path, locale, element) => {
    let value = element;
    let pathSegments = path.split(".");
    for (let segment of pathSegments) {
        value = value[segment] ? (value[segment][locale] ? value[segment][locale] : value[segment]) : null;
    }
    return value?.toUpperCase();
};

export const filterApplication = (locale, context, application) => {
    const appFilters = context.filters;
    let appMatches = true;
    context.filtersCriteria &&
        Object.entries(context.filtersCriteria).forEach(([filter, value]) => {
            if (value && appFilters[filter] && !appFilters[filter].match(application, value, locale)) {
                appMatches = false;
            }
        });
    return appMatches;
};

export const searchApplication = (locale, searchCriteria, application) => {
    let currentVersion = application.versions?.length ? application.versions[application.currentVersionIndex] : false;
    return (
        application.name[locale]?.toUpperCase().indexOf(searchCriteria?.toUpperCase()) >= 0 ||
        application.author?.toUpperCase().indexOf(searchCriteria?.toUpperCase()) >= 0 ||
        (currentVersion && currentVersion.brief[locale]?.toUpperCase().indexOf(searchCriteria?.toUpperCase()) >= 0) ||
        (currentVersion &&
            currentVersion.description[locale]?.toUpperCase().indexOf(searchCriteria?.toUpperCase()) >= 0)
    );
};
